export default function({
    settings = {},
    name,
    onChange
}) {

    return [
        {
            type: "InputText",
            data: {
                onChange,
                attrs: {
                    placeholder: "Введите название",
                    value: settings[name],
                }
            }
        }
    ]
}